import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../utils/constants';

// Polling Hook - Replaces WebSocket for better production stability.
//
// Ajustes de carga:
//   - Intervalo 30s (antes 15s): el feed de actividad no necesita 15s; esto
//     ya reduce a la mitad las llamadas a /api/dashboard/recent-activity.
//   - Pausa en segundo plano: si la pestaña no está visible, se detiene el
//     polling (y se retoma al volver, con un refresco inmediato). Evita seguir
//     golpeando el endpoint en pestañas que nadie está mirando.
const POLL_INTERVAL_MS = 30000;

export const useActivityPolling = (userId) => {
  const [activities, setActivities] = useState([]);
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    if (!userId) return;

    let interval = null;

    const fetchActivities = async () => {
      // No pollear si la pestaña está en segundo plano.
      if (typeof document !== 'undefined' && document.hidden) return;
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${BACKEND_URL}/api/dashboard/recent-activity?limit=10`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          setActivities(data.activities || data || []);
          setIsConnected(true);
        }
      } catch (error) {
        console.error('Error fetching activities:', error);
        setIsConnected(false);
      }
    };

    const start = () => {
      if (interval) return;
      interval = setInterval(fetchActivities, POLL_INTERVAL_MS);
    };
    const stop = () => {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    };

    // Al cambiar la visibilidad: pausar en background, retomar (con refresco
    // inmediato) al volver al primer plano.
    const handleVisibility = () => {
      if (document.hidden) {
        stop();
      } else {
        fetchActivities();
        start();
      }
    };

    // Arranque: fetch inicial + interval solo si la pestaña está visible.
    fetchActivities();
    if (!document.hidden) start();
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [userId]);

  return { activities, isConnected };
};

export default useActivityPolling;
